import SchemaPropTypes from '@get-bridge/learn-legacy-shared/dist/shared/SchemaPropTypes';
import TaskSource from './TaskSource';
const { instanceOf, number, object, string, shape } = SchemaPropTypes;

export default shape({
  id: number,
  uid: string.isRequired,
  source: TaskSource.isRequired,
  assigneeId: number,
  authorId: number,
  description: string.isRequired,
  completedAt: instanceOf(Date),
  dueAt: instanceOf(Date),
  createdAt: instanceOf(Date),
  goalId: number,
  agendaId: number,
  oneOnOneWithId: number,
  assignee: object,
  author: object,
  oneOnOneWith: object,
});



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/schemas/TaskPayload.js